/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function getVhsShippingData() {
  var element = document.getElementById('vhs-shipping-data');

  if (!element) {
    return null;
  }

  try {
    return JSON.parse(element.textContent);
  } catch (error) {
    console.error('Kon verzendgegevens niet lezen:', error);
    return null;
  }
}

function findVhsShippingElement() {
  var elements = Array.from(
    document.querySelectorAll('p, div')
  );

  return elements.find(function(element) {
    var text = element.textContent.trim();

    return (
      text.indexOf('Geschatte verzendtermijn:') === 0 &&
      text.length < 200
    );
  });
}

function updateVhsShippingEstimate(variantId) {
  var data = getVhsShippingData();
  var element = findVhsShippingElement();

  if (!data || !element || !variantId) {
    return;
  }

  var quantity = data.variants[String(variantId)];

  if (typeof quantity === 'undefined') {
    return;
  }

  if (quantity > 0) {
    element.innerHTML =
      '<strong>Geschatte verzendtermijn:</strong> Verzending binnen 1 werkdag';
  } else {
    element.innerHTML =
      '<strong>Geschatte verzendtermijn:</strong> ' +
      (data.backorder || 'Levertijd op aanvraag');
  }
}

document.addEventListener('variant:changed', function(event) {
  if (!event.detail || !event.detail.variant) {
    return;
  }

  updateVhsShippingEstimate(event.detail.variant.id);
});

document.addEventListener('DOMContentLoaded', function() {
  var data = getVhsShippingData();

  if (data) {
    updateVhsShippingEstimate(data.selected_variant);
  }
});